import React from 'react';
import { ProtectedRoute as LibProtectedRoute } from 'library';
import type { IProtectedRouteProps } from 'library';

const UNAUTHORIZED_REDIRECT_PATH = import.meta.env
  .VITE_UNAUTHORIZED_REDIRECT_PATH as string;

import { RoutesConfig } from '../routes/config';

const ProtectedRoute: React.FC<
  Omit<
    IProtectedRouteProps,
    'authenticatedRedirect' | 'unauthenticatedRedirect'
  >
> = props => {
  return (
    <LibProtectedRoute
      {...props}
      authenticatedRedirect={RoutesConfig.Home.fullPath}
      unauthenticatedRedirect={
        UNAUTHORIZED_REDIRECT_PATH || RoutesConfig.Auth.fullPath
      }
    />
  );
};

export default ProtectedRoute;
